import { render } from "./system.vue?vue&type=template&id=458e5436&scoped=true"
import script from "./system.vue?vue&type=script&lang=js"
export * from "./system.vue?vue&type=script&lang=js"

import "./system.vue?vue&type=style&index=0&id=458e5436&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-458e5436"

export default script